import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Avatar,
  Box,
  InputLabel,
  Select,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { GlobalStyles } from "@mui/system";
import { IconButton } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";
import { useLocation } from "react-router-dom";

import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import { useParams } from "react-router-dom";
import StudentPaymentList from "./StudentPaymentsList";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
function StudentPaymentsTransactionList() {
  const { oId,board } = useAuth();
   const location = useLocation();
       const { CategoryType } = location.state || {};
       const Type =CategoryType?.categoryType;
       const student = JSON.parse(sessionStorage.getItem("paymentListStudent"));

     const navigate = useNavigate();
   const { admissionNumber,rolePayment } = useParams();
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [transactionData, setTransactionData] = useState([]);

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
};


  // useEffect(() => {
  //   const fetchDialogTableData = async () => {
  //     if (!admissionNumber || !rolePayment) return; // Prevent API call if no admission number is selected

  //     setLoading(true);
  //     try {
  //       const response = await fetch( `${baseUrl}/api/transaction/getAllTransaction/${admissionNumber}/${oId}/${rolePayment}`
  //       );
  //       if (!response.ok) {
  //         throw new Error("Failed to fetch data");
  //       }

  //       const data = await response.json();
  //       console.log("Fetched Data:", data);
  //       setTransactionData(data || []); // Ensure it's always an array
  //     } catch (error) {
  //       console.error("Error fetching Bus Numbers:", error);
  //       setTransactionData([]); // Ensure state remains consistent
  //     } finally {
  //       setLoading(false); // Set loading to false after fetching
  //     }
  //   };

  //   fetchDialogTableData();
  // }, [admissionNumber,rolePayment, oId]); // Re-fetch when `selectedadmissionNo` or `oId` changes

useEffect(() => {
  const fetchDialogTableData = async () => {
    if (!admissionNumber || !rolePayment) return;

    setLoading(true);
    try {
      let response;

      if (rolePayment === "additional_fee") {
        response = await fetch(
          `${baseUrl}/api/studentSoldItems/getInvoiceSummaryByStudentId/${student.studentId}`
        );
      } else {
        response = await fetch(
          `${baseUrl}/api/transaction/getAllTransaction/${admissionNumber}/${oId}/${rolePayment}`
        );
      }

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      console.log("Fetched Data:", data);
      setTransactionData(data || []); // Always set an array
    } catch (error) {
      console.error("Error fetching dialog table data:", error);
      setTransactionData([]); // Prevent stale data
    } finally {
      setLoading(false);
    }
  };

  fetchDialogTableData();
}, [admissionNumber, rolePayment, oId]);


  const roleLabels = {
  admission_fee: "Admission Fee",
  bus_fee: "Bus Fee",
  tution_fee: "Tuition Fee",
  other_fee: "Miscellaneous  Fee",
  exam_fee: "Exam Fee",
  hostel_fee: "Hostel Fee",
  additional_fee: "Additional Fee",
};

const readableLabel = roleLabels[rolePayment] || "Fee";


const cellStyle = {
  borderRight: "1px solid #ddd",
  padding: "2px",
  textAlign: "center",
  backgroundColor: "#fff9c4",
  fontWeight: "bold",
  fontSize: "14px",
};

const tabcellStyle = {
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                    
};

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
    <Card
      style={{
        // margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        // maxHeight: "100vh",
        // overflow: "hidden",
        width: "100%",
      }}
    >
      <CardContent>
         
        <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
            <KeyboardBackspaceIcon fontSize="medium" />
          </IconButton>
          <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
    {`${readableLabel} Transaction List`}
  </Typography>
        </Box>

   

        <GlobalStyles
          styles={{
            ".custom-sidebar-scrollbar": {
              scrollbarWidth: "thin", // For Firefox
              scrollbarColor: "grey #e0e0e0",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar": {
              width: "6px", // For WebKit-based browsers
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
              background: "#f1f1f1", // Track color
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
              backgroundColor: "grey", // Thumb color
              borderRadius: "10px",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        />

        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "800px",
            overflow: "auto",
            //  maxHeight: "800px",
            //   overflow: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  S.No
                </TableCell>
                {rolePayment === "additional_fee" ? (
        <>
          <TableCell sx={cellStyle}>Bill Date</TableCell>
          <TableCell sx={cellStyle}>Bill No</TableCell>
          <TableCell sx={cellStyle}>Grand Total (₹)</TableCell>
          <TableCell sx={cellStyle}>Action</TableCell>
        </>
      ) : (
        <>
          <TableCell sx={cellStyle}>Payment Date</TableCell>
          <TableCell sx={cellStyle}>Amount Paid</TableCell>
          <TableCell sx={cellStyle}>Transaction Id</TableCell>
          <TableCell sx={cellStyle}>Payment Type</TableCell>
          <TableCell sx={cellStyle}>Fee Receipt</TableCell>
        </>
      )}

              </TableRow>
            </TableHead>

            <TableBody>
              {/* {!hasFetchedOnce || loading ? ( */}
              {loading ? (
                <TableRow>
                  <TableCell
                    colSpan={12}
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                    >
                      <CircularProgress />
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        Loading Data...
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : transactionData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                transactionData.map((row, index) => (
                  <TableRow
                    key={row.id}
                    style={{
                      backgroundColor: "white",
                      transition: "background-color 0.3s",
                      height: "30px", // Reduced row height
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white"; // Default color
                    }}
                  >
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    {rolePayment === "additional_fee" ? (
        <>
         <TableCell sx={tabcellStyle}>{row.soldDate}</TableCell>
            <TableCell sx={tabcellStyle}>{row.invoiceNo}</TableCell>
            <TableCell sx={tabcellStyle}>₹${row.finalAmount}</TableCell>
        </>
      ) : (
        <>
          {/* <TableCell sx={tabcellStyle}>{row.paymentDate}</TableCell> */}
          <TableCell sx={tabcellStyle}>
              {formatDate(row.paymentDate)}
            </TableCell>
            <TableCell sx={tabcellStyle}>{row.paymentAmount}</TableCell>
            <TableCell sx={tabcellStyle}>{row.transactionId || "N/A"}</TableCell>
            <TableCell sx={tabcellStyle}>{row.payMethod}</TableCell>
          
        </>
      )}
          <TableCell
                      sx={{
                        borderLeft: "1px solid #ddd",
                        padding: "4px",
                        textAlign: "center",
                      }}
                    >
                      <Button
                        type="button"
                      
                        onClick={() => {
                            // Store data in sessionStorage
                            sessionStorage.setItem("receiptRowData", JSON.stringify(row));
                            sessionStorage.setItem("receiptCategoryType", CategoryType?.category || "");
                            // Navigate
                            if(rolePayment === "additional_fee"){
                               sessionStorage.setItem("soldItemData", JSON.stringify(row));
                               navigate(`/BooksReceipt/${row.invoiceNo}`)
                            }else{
                               navigate(`/StudentPaymentsReceipts/${admissionNumber}/${row.rolePayment}`);
                            }
                           
                          }}

                        sx={{
                          backgroundColor: "#1976d2",
                          color: "white",
                          fontWeight:'bold',
                          fontSize: "0.6rem", // Reduces the font size
                          height: "25px", // Reduces the height
                          "&:hover": {
                            backgroundColor: "#1565c0",
                          },
                        }}
                      >
                        {rolePayment === "additional_fee" ? "Bill Receipt" : "Receipt"}
                      </Button>
                    </TableCell>

                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

   
      </CardContent>
    </Card>
    </Box>
  );
}

export default StudentPaymentsTransactionList;